import { Vue,Component,Prop,Watch} from 'vue-property-decorator';
// import showNotificationStaffModal from "../NotificationstatusbySubscriber/NotificationstatusbySubscriber.vue"
import {notificationStatusByStaffList,notificationStatusListBySubscriber,notificationSubscriberList} from "@/types/Component";


@Component({
    // components:{
    //     showNotificationStaffModal
    // }
})
   
export default class NotificationByStaffModal extends Vue {

  /**
     * モーダルからのコールバック
     */
   @Prop() isShowNotificationBystaffModal!: boolean

   @Prop({ default: null })
   private notificationId!: string

   @Prop({ default: null })
   private subscriptionId!: string
   
  @Prop({ default: null })
  private subscriberDetails!: notificationSubscriberList[];

   @Prop({ default: null })
   private notificationStatusListBySubscriber!: notificationStatusListBySubscriber[]

   private notificationStatusByStaffList =[] as notificationStatusByStaffList []

   baseUrl = "/notificationStatus";
   private notificationTitle  =""
   private notificationIsImportant :any  =""
   private sortByUserNameASC = false
   private sortByAuthorityASC = false
   private sortBystatusASC = false
   private sortByReadDateASC = false

    closeModal(){
        this.$emit('update:isShowNotificationBystaffModal', false);
    }
   
    @Watch('isShowNotificationBystaffModal')
    private async onChangeShowNotificationBystaffModal(notificationId:string){
        if(this.isShowNotificationBystaffModal && this.notificationId !=null){
          const notificationStaff = await this.getNotificationByStaff(this.notificationId)
        }
    }


    private async getNotificationByStaff(id :string){
       const tenantId = this.subscriptionId;
            const notificationDetailsByStaff = await this.$apiClient.doRequest('get', `${this.baseUrl}/notification_status_staff/${tenantId}/${id}`)
            .then((res)=>{
                this.notificationStatusByStaffList=res.notificationStatus
            })
            this.notificationTitle = (this.notificationStatusListBySubscriber.find((item: any) => id === item.notificationId) as any)?.notificationTitle;
            this.notificationIsImportant = (this.notificationStatusListBySubscriber.find((item: any) => id === item.notificationId) as any)?.isImportant;
            return notificationDetailsByStaff;
        }

        sortByUserName(isSwitchAsc?: boolean) {
            this.sortByUserNameASC = isSwitchAsc ? !this.sortByUserNameASC : this.sortByUserNameASC
            this.notificationStatusByStaffList.sort((a :any, b:any) => {
                const valueA = a.staffName;
                const valueB = b.staffName;
                return this.sortByUserNameASC ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)

            })
          }


          sortByAuthority(isSwitchAsc?: boolean) {
            this.sortByAuthorityASC = isSwitchAsc ? !this.sortByAuthorityASC : this.sortByAuthorityASC
            this.notificationStatusByStaffList.sort((a:any, b:any) => {
                const valueA = a.authority;
                const valueB =b.authority;
                return this.sortByAuthorityASC ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
            })
          }

          sortByReadDate(isSwitchAsc?: boolean) {
            this.sortByReadDateASC = isSwitchAsc ? !this.sortByReadDateASC : this.sortByReadDateASC
            this.notificationStatusByStaffList.sort((a :any, b:any) => {
            if (a.notificationReadDate === null && b.notificationReadDate === null) {
              return 0;
            } else if (a.notificationReadDate === null) {
              return 1;
            } else if (b.notificationReadDate === null) {
            return -1;
            } else {
            return this.sortByReadDateASC ? Date.parse(a.notificationReadDate) - Date.parse(b.notificationReadDate) : Date.parse(b.notificationReadDate) - Date.parse(a.notificationReadDate)
            }
            })
            }

          sortBystatus(isSwitchAsc?: boolean) {
            this.sortBystatusASC = isSwitchAsc ? !this.sortBystatusASC : this.sortBystatusASC
            this.notificationStatusByStaffList.sort((a:any, b:any) => {
                const valueA = a.isNotificationRead;
                const valueB =b.isNotificationRead;
                return this.sortBystatusASC ? valueA- valueB : valueB - valueA
            })
          }
          private dateFormat(date: Date) {
            if(date){
              const year = new Date(date).getFullYear();
              const month = ("0" + (new Date(date).getMonth() + 1)).slice(-2);
              const day = ("0" + new Date(date).getDate()).slice(-2);
              return year + '/' + month + '/' + day;
            }
            return "-";
            }
    }
